package link.erpango.quip.utils

object CalendarUtils : ICalendarUtils {

    private var impl: ICalendarUtils? = null

    fun create(impl: ICalendarUtils) {
        this.impl = impl
    }

    override fun addEvent(title: String, description: String, startMs: Long) {
        impl?.addEvent(title, description, startMs)
    }
}
